export enum PayCalculatorTypes {
  Total,
  Tip,
  TotalAndTip,
  Given,
  Change,
  GivenForTipping,
}
